import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AiClearButton',
  props: {
    onClick: { type: Function },
    disabled: { type: Boolean },
    theme: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    disabled: _ctx.disabled,
    class: _normalizeClass(["ai-clear-button", {
      'white': _ctx.theme === 'white',
      'primary-gradient': _ctx.theme === 'primary-gradient',
      'secondary-gradient': _ctx.theme === 'secondary-gradient',
      'accent-secondary': _ctx.theme === 'accent-secondary',
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})